// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"style_menuBlock__1p5z_","menuItem":"style_menuItem__37SIj"};